export const isLocal = () => process.env.NUXT_PUBLIC_ENV === 'local'

export const isDev = () => process.env.NUXT_PUBLIC_ENV === 'development'

export const isProd = () => process.env.NUXT_PUBLIC_ENV === 'production'
